module.exports = __webpack_public_path__ + "img/4.a7c4cb54.png";